import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import "./index.css";
import { useWindowSize } from "../../hooks";
import HotelCard880 from "./includes/HotelCard880";
import HotelCard598 from "./includes/HotelCard598";
import HotelCard392 from "./includes/HotelCard392";
import { fetchMinPrice } from "./includes/functions";
import moment from "moment/moment";
import { names } from "../../../Styles/names";
import theme from "../../../Styles/theme.json";

export default function HotelListModal({
  startDate,
  endDate,
  adultsCount,
  children,
  babiesCount,
  hotelId,
  promo
}) {
  const size = useWindowSize();
  const [hotelsList, setHotelsList] = useState([]);
  const [pricesList, setPricesList] = useState([]);
  const [filterState, setFilterState] = useState({
    date_in: moment(startDate).format("yyyy-MM-DD"),
    date_out: moment(endDate).format("yyyy-MM-DD"),
    adults: adultsCount,
    children: +children,
    babies: +babiesCount,
    promo: promo,
  });

  useEffect(() => {
    setPricesList([])
    fetch(process.env.REACT_APP_API_URL_DIRECTLY + "api/hotels/list/?hotel_id=" + hotelId, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setHotelsList(result);
        result.forEach((hotel) => {
          fetchMinPrice({
            ...filterState,
            hotel_id: hotel.id,
            api_token:
              "uVxMpwzW5tQQj6UaI9TYcMWMJljsw3n5MUoMjvsu4mUsvuaXetvgPzlLhiKa",
          })
            .then((res) => res.json())
            .then((result) => {
              setPricesList((pr) => [
                ...pr,
                {
                  hotel_id: hotel.id,
                  min_price: (result && result[0] && result[0]["min_price"]) ?? 0,
                  isLoaded: true
                },
              ]);
            })
            .catch((e) => console.log(e));
        });
      })
      .catch((error) => console.log(error));
  }, [filterState]);

  const handleOpenCallback = () => {
    setFilterState({
      date_in: moment(startDate).format("yyyy-MM-DD"),
      date_out: moment(endDate).format("yyyy-MM-DD"),
      adults: adultsCount,
      children: children,
      babies: +babiesCount,
      promo: promo
    });
  };


  useEffect(() => {
    if (hotelsList.length > 0 && pricesList.length === hotelsList.length) {
      const pricesMap = pricesList.reduce((acc, price) => {
        acc[price.hotel_id] = price.min_price;
        return acc;
      }, {});

      const sortedHotels = [...hotelsList].sort((a, b) => {
        const minPriceA = pricesMap[a.id] || 0;
        const minPriceB = pricesMap[b.id] || 0;

        if (minPriceA === 0 && minPriceB !== 0) {
          return 1;
        }
        if (minPriceA !== 0 && minPriceB === 0) {
          return -1;
        }
        return 0;
      });

      setHotelsList(sortedHotels);
    }
  }, [pricesList])

  return (
    <Popup
      className="hotellist-modal"
      contentStyle={{
        // width: "75%",
        backgroundColor: theme.background.secondary,

        overflowX: "scroll",
      }}
      onOpen={handleOpenCallback}
      trigger={
        <button
          className={`hotellist-modal__button-opener ur-mb-1 ${names.backgrond.button.secondary}`}
        >
          <img src="/bookform/images/icons/swap_hotel.svg" alt="swap" />
          <span
            className={`hotellist-modal__button-opener-title ${names.text.primary}`}
          >
            Сменить отель
          </span>
        </button>
      }
      modal
    >
      {(close) => (
        <>
          <div className="hotellist-modal__header">
            <div className={`hotellist-modal__title ${names.text.primary}`}>
              Сменить отель
            </div>
            <button
              className={`hotellist-modal__close-btn ${names.backgrond.button.quaternary}`}
              onClick={close}
            ></button>
          </div>
          <div className="hotellist-modal__wrapper">
            <div
              className={`hotellist-modal__subheader ${names.text.primary}`}
            >
              Выберите отель
            </div>
            {hotelsList.map((hotel) => {
              const conveniences = hotel.conveniences
                ? hotel?.conveniences?.split(",")
                : [];
              const stars = parseInt(hotel.data.stars);
              const imagePath =
                process.env.REACT_APP_API_URL_DIRECTLY.slice(0, -1) +
                hotel.image_path;
              const minPriceObj = pricesList.find(
                (it) => it.hotel_id === hotel.id
              );
              const isMinPriceLoaded = minPriceObj?.isLoaded;
              const minPrice = minPriceObj?.min_price;

              if (size.width < 880 && size.width > 598) {
                return (
                  <HotelCard880
                    hotel={hotel}
                    key={hotel.id}
                    minPrice={minPrice}
                    stars={stars}
                    imagePath={imagePath}
                    conveniences={conveniences}
                    date_in={filterState.date_in}
                    date_out={filterState.date_out}
                    isMinPriceLoaded={isMinPriceLoaded}
                  />
                );
              } else if (size.width <= 598 && size.width > 392) {
                return (
                  <HotelCard598
                    hotel={hotel}
                    key={hotel.id}
                    minPrice={minPrice}
                    stars={stars}
                    imagePath={imagePath}
                    conveniences={conveniences}
                    date_in={filterState.date_in}
                    date_out={filterState.date_out}
                    isMinPriceLoaded={isMinPriceLoaded}
                  />
                );
              } else if (size.width <= 392) {
                return (
                  <HotelCard392
                    hotel={hotel}
                    key={hotel.id}
                    minPrice={minPrice}
                    stars={stars}
                    imagePath={imagePath}
                    conveniences={conveniences}
                    date_in={filterState.date_in}
                    date_out={filterState.date_out}
                    isMinPriceLoaded={isMinPriceLoaded}
                  />
                );
              } else {
                return (
                  <HotelCard880
                    hotel={hotel}
                    key={hotel.id}
                    minPrice={minPrice}
                    stars={stars}
                    imagePath={imagePath}
                    conveniences={conveniences}
                    date_in={filterState.date_in}
                    date_out={filterState.date_out}
                    isMinPriceLoaded={isMinPriceLoaded}
                  />
                );
              }
            })}
          </div>
        </>
      )}
    </Popup>
  );
}
